import {
  Component,
  DestroyRef,
  HostBinding,
  inject,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { PrintService } from '../../services/print/print.service';
import { SessionService } from '../../services/session/session.service';

@Component({
  selector: 'layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.less'],
  standalone: false
})
export class LayoutComponent implements OnInit {
  @HostBinding('style.padding-left') paddingLeft: string;

  public isPrintMode: boolean;
  private readonly destroyRef = inject(DestroyRef);

  constructor(
    public sessionService: SessionService,
    private printService: PrintService,
  ) {
    if (sessionService.isPublic) {
      this.paddingLeft = '0';
    } else {
      this.paddingLeft = '5rem';
    }
  }

  public ngOnInit(): void {
    this.printService.printMode$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(isPrintMode => {
      this.isPrintMode = isPrintMode;
    });
  }
}
